import * as Yup from 'yup';

export interface AddKioskFormState {
  serialNumber: string;
}

export const formValidation: Yup.SchemaOf<AddKioskFormState> = Yup.object().shape({
  serialNumber: Yup.string().max(40, 'Max size 40 characters').required('Enter a serial number'),
});
